import { render, staticRenderFns } from "./GameSettings.vue?vue&type=template&id=05dd7558&scoped=true&"
import script from "./GameSettings.vue?vue&type=script&lang=js&"
export * from "./GameSettings.vue?vue&type=script&lang=js&"
import style0 from "./GameSettings.vue?vue&type=style&index=0&id=05dd7558&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05dd7558",
  null
  
)

export default component.exports